




































import api from "@/api/api"
import updateTdk, { formatTDK } from "@/utils/tdk"
import { Component, Vue, Prop } from "vue-property-decorator"

@Component({
  name: "Tag",
  beforeRouteUpdate(to, from, next) {
    if (to.params) {
      this.sort = "download:-1"
      this.fetchData(to.params.tag_name)
    }
    next()
  },
  components: {
    GameItem: () => import("./components/GameItem.vue"),
    Empty: () => import("@/components/empty/empty.vue"),
    LoadMore: () => import("@/components/loadMore/loadMore.vue")
  },
  tdk() {
    return this.$store.state.tdk
  }
})
export default class Tag extends Vue {
  sort = "download:-1"
  tabsOptions = [
    { label: "推荐", value: "download:-1" },
    { label: "最新", value: "publish:-1" }
  ]
  async onSort() {
    this.loading = true
    await this.$root.$tstore.modules.gameList.actions.FETCH_TAGS({
      filter: this.$route.params.tag_name,
      sort: this.sort,
      view: "web"
    })
    this.loading = false
  }

  loading = false

  get tags() {
    return this.$root.$tstore.modules.gameList.getters.tags
  }

  get tagName() {
    return this.$root.$tstore.modules.gameList.getters.tagName
  }

  // ssr hook
  serverPrefetch() {
    return this.fetchData()
  }

  async beforeMount() {
    if (!this.tags) {
      try {
        await this.fetchData()
      } catch (error) {
        this.$router.push({ name: "404" })
      }
    }
  }

  fetchData(tag?: string) {
    return new Promise(async (resolve, reject) => {
      try {
        await this.$root.$tstore.modules.gameList.actions.FETCH_TAGS({
          filter: `tag_seq:${tag || this.$route.params?.tag_name}`,
          sort: this.sort,
          view: "web"
        })

        const tdkResp = await api.tdk.typeSeo(
          "tag",
          encodeURI(tag || this.$route.params?.tag_name)
        )
        const { keyword, description, title, name } = tdkResp.data
        this.$root.$tstore.modules.tdk.mutations.SET_TDK(
          formatTDK({ keywords: keyword, description, title }, [
            {
              replaceKey: "{标签名称}",
              replaceVal: name || ""
            }
          ])
        )
        updateTdk.call(this)

        this.$root.$tstore.modules.gameList.mutations.SET_TAG_NAME({ name })

        resolve("")
      } catch (error) {
        reject(error)
      }
    })
  }
  handleBack() {
    this.$router.go(-1)
  }

  handleSearch() {
    this.$router.push("/search")
  }

  destroyed() {
    console.log("destroyed")
    this.$store.commit("gameList/SET_TAGS", {
      gameSearchList: null
    })
  }
}
